import { keyframes } from '@mui/material/styles';

export const shakeAnimationKeyframes = keyframes`
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
  20%, 40%, 60%, 80% { transform: translateX(10px); }
`;

export const shakeAnimation = {
  animation: `${shakeAnimationKeyframes} 0.6s`,
};
